// Agreements
export const AGREEMENTS = '/agreement';
export const EDIT_AGREEMENT = agreementId => `/agreement/${agreementId}`;

// Tag details
export const TAG_DETAILS = tagNumber => `/tag/details/${tagNumber}`;

// Change subscription plan
export const SUBSCRIPTION_PLAN_CHANGE = tagNumber => `/tag/details/subscription/${tagNumber}`;